import React, { useState } from 'react';
import { Modal, Select, Input, Empty } from 'antd';
import { DataSourceTableType } from '@/types/dataMap';

interface AddTableModalProps {
  visible: boolean;
  onClose: () => void;
  onTableAdded: (table: DataSourceTableType) => void;
  dataSourceTable: DataSourceTableType[];
}

const AddTableModal: React.FC<AddTableModalProps> = ({ visible, onClose, onTableAdded, dataSourceTable }) => {
  // Schema选择状态
  const [selectedSchema, setSelectedSchema] = useState('AAA');
  // 表名搜索状态
  const [tableSearch, setTableSearch] = useState('');

  // 处理表选择
  const handleTableSelect = (table: DataSourceTableType) => {
    onTableAdded(table);
    onClose();
  };

  return (
    <Modal
      title="添加表"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={600}
      centered
      style={{ maxHeight: '90vh', overflow: 'hidden' }}
    >
      <div className="py-6 px-8" style={{ maxHeight: '60vh', overflow: 'hidden' }}>
        {/* Schema 选择 */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">Schema</label>
          <Select 
            className="w-48 text-sm"
            value={selectedSchema}
            onChange={(value) => setSelectedSchema(value)}
            style={{ backgroundColor: '#f5f5f5' }}
            disabled
          >
            <Select.Option value="AAA">AAA</Select.Option>
          </Select>
        </div>

        {/* 数据表名称搜索 */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">数据表名称</label>
          <Input 
            className="text-sm"
            value={tableSearch}
            onChange={(e) => setTableSearch(e.target.value)}
            placeholder="搜索表名称"
            prefix={
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M21 21L16.65 16.65" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            }
          />
        </div>

        {/* 表列表 */}
        <div className="h-[300px]">
          <div className="border border-gray-200 rounded-md overflow-hidden h-full flex flex-col">
            <div className="flex border-b border-gray-200 bg-gray-50 pr-[6px]">
              <div className="px-4 py-2 text-sm font-medium text-gray-700 w-1/2">表名称</div>
              <div className="px-4 py-2 text-sm font-medium text-gray-700 w-1/2">描述</div>
            </div>
            <div className="flex-1 overflow-y-auto">
              {(() => {
                const filteredTables = dataSourceTable.filter(table => 
                  table.tableName.toLowerCase().includes(tableSearch.toLowerCase()) || 
                  (table.comment && table.comment.toLowerCase().includes(tableSearch.toLowerCase()))
                );
                return filteredTables.length > 0 ? (
                  filteredTables.map((table, index) => (
                    <div 
                      key={index} 
                      className="flex hover:bg-gray-50 cursor-pointer px-2"
                      onClick={() => handleTableSelect(table)}
                    >
                      <div className="px-4 py-3 text-sm text-blue-600 w-1/2">{table.tableName}</div>
                      <div className="px-4 py-3 text-sm text-gray-700 w-1/2">{table.comment || '-'}</div>
                    </div>
                  ))
                ) : (
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="暂无数据" />
                );
              })()}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddTableModal;